import * as React from "react";
import {MoneyTextBoxEditor} from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import {RadiosEditor} from "../../../../../../../react-core/Html/RadiosEditor";
import {CurrencyCode} from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import {SubAccountType} from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import {TransferType} from "../../../../../../../Wrap/Constants/Enums/Domain/TransferType";
import {IProcessComponentProps, ProcessComponent} from "../../../../../../Shared/Process/Process/ProcessComponent";
import {CedingScheme} from "./CedingScheme";

import {SelectEditor} from "../../../../../../../react-core/Html/SelectEditor";
import {
    ExternalIsaContributionTypes,
    ExternalIsaContributionTypesMap,
    IsaContents,
    TransferLocationTypes,
    TransferLocationTypesMap,
} from "../../ISA/Resource/Contents";
import {
    ExternalIsaContributionType
} from "../../../../../../../Wrap/Constants/Enums/Transfer/ExternalIsaContributionType";
import {TextBoxEditor} from "../../../../../../../react-core/Html/TextBoxEditor";
import {ValidatorContents} from "../../../../../Common/ValidatorHelper";
import {AlphanumericWithSpace} from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import {DatePicker} from "../../../../../../../react-core/Datepicker/DatePicker";
import {JsonDateParser} from "../../../../../../../react-core/Utils/JsonDateParser";
import {ContentDatePicker} from "../../../../../../Shared/Entities/Constants/DateConstants";
import {TaxYearHelper} from "../../Helpers/TaxYearHelper";
import {datePickerOptions, processTypeEnum} from "../../Resource/Contents";
import {IsaTransfer} from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaTransfer";
import {ReRegInvestmentSeletion} from "./ReRegInvestmentSeletion";
import {ServiceProposition} from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import {Method} from "../../../../../../Shared/Common/Common";
import {AccountSearchPopup} from "./AccountSearchPopup";
import {Lightbox, LightboxType} from "../../../../../../../react-core/Html/Components/Lightbox";
import {
    TransferDestinationAccountModel
} from "../../../../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import {ClientDetails} from "../../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { AccountSearchForIsaCashPopup } from "./AccountSearchforISACashPopup";

interface ISingleTransferInIsaProps extends IProcessComponentProps {
    isPost: boolean;
    index: number;
    data: IsaTransfer;
    isQuote: boolean;
    hasCashIsa: boolean;
    accountServiceProposition: ServiceProposition;
    claccountId?: string;
    jouneryType?: processTypeEnum;
    clientDetails?: ClientDetails;
}

interface ISingleTransferInIsaState {
    displayExceedIsaAllowanceError: boolean;
    showLocation: boolean;
    showAccountSearch: boolean;
    isLoadingInvestments: boolean;
    transferDestinationAccount?: TransferDestinationAccountModel;
}

export class SingleTransferInIsa extends ProcessComponent<ISingleTransferInIsaProps, ISingleTransferInIsaState> {
    constructor(props: ISingleTransferInIsaProps) {
        super(props);
        this.state = {
            displayExceedIsaAllowanceError: false,
            showLocation:
                this.props.data?.InternalTransferFromExistingWrapCashIsa == false
                    ? true
                    : this.props.data?.InternalTransferFromExistingWrapCashIsa == true && this.props.hasCashIsa
                    ? true
                    : false,
            showAccountSearch: false,
            isLoadingInvestments: false,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.onChange({
            CashIsaToBeTransferredToSSIsa:
                this.props.data?.CashIsaToBeTransferredToSSIsa != null
                    ? this.props.data?.CashIsaToBeTransferredToSSIsa
                    : true,
        });
    }

    instrumentsCheck(): string[] {
        const { data } = this.props;
        const err: string[] = [];

        if (
            data?.ProviderDetails?.Name &&
            data?.ProviderDetails?.Name?.toLowerCase() !== "standard life savings ltd wrap" &&
            data?.ProviderDetails?.Name?.toLowerCase() !== "aps allowance subscription" &&
            data?.TransferType != TransferType.Cash &&
            data?.InvestmentsToBeTransferredInSpecie == true
        ) {
            const instruments = data.Instruments;
            if (instruments.length === 0) {
                err.push("No instrument has been selected");
            } else if (instruments.length > 0) {
                for (let index = 0; index < instruments.length; index++) {
                    const strs = [];
                    if (!(instruments[index].Units > 0)) {strs.push("Unit");}
                    strs.length &&
                        err.push(
                            `Please input an valid ${strs.join(" and ")} for the ${Method.Oridinal(
                                index + 1
                            )} instrument`
                        );
                }
            }
        }
        return err;
    }

    isValid() {
        let flag = super.isValid();
        const cashIsaValid = !this.props.hasCashIsa && this.props.data?.InternalTransferFromExistingWrapCashIsa;
        if (cashIsaValid) {
            this.props.showErrorMsgPopUp(["No ISA cash sub account found for internal transfer."], true);
        }

        const instrumentValidMsg = this.instrumentsCheck();

        if (instrumentValidMsg.length > 0) {
            this.props.showErrorMsgPopUp(instrumentValidMsg, true);
            flag = false;
        }
        return flag && !cashIsaValid;
    }
    render() {
        const { data, onChange } = this.props;
        const { showAccountSearch, isLoadingInvestments } = this.state;
        const currentTaxYear = TaxYearHelper.GetCurrentTaxYear();
        const currentTaxYearStartDate = TaxYearHelper.GetTaxYearStartDate(currentTaxYear);
        const currentTaxYearEndDate = TaxYearHelper.GetTaxYearEndDate(currentTaxYear);
        const subAccountType = SubAccountType.StocksIsa;
        const displayTextBoxEditor = !this.props.isQuote && (data?.ProviderDetails?.Name?.toLowerCase() != "aps allowance subscription" || data?.ProviderDetails?.Name?.toLowerCase() == "aps allowance subscription" && !data?.InvestmentsToBeTransferredInSpecie);
        const displayReRegInvestmentSeletion = data?.TransferType == TransferType.InSpecie && (data?.ProviderDetails?.Name?.toLowerCase() != "aps allowance subscription" || !data?.InvestmentsToBeTransferredInSpecie && data?.ProviderDetails?.Name?.toLowerCase() == "aps allowance subscription");


        return (
            <>
                <h4>Transfer type</h4>
                <RadiosEditor
                    cssWrapper="rg-150 mb-20"
                    options={[TransferType.Cash, TransferType.InSpecie]}
                    getText={(v) => (v == TransferType.Cash ? "Cash" : "S&S ISA")}
                    onChange={(v) =>
                        onChange({
                            TransferType: v,
                            CurrentValue: null,
                            ReRegisterValue: null,
                            InvestmentsToBeTransferredInSpecie: null,
                            InternalTransferFromExistingWrapCashIsa: null,
                            Location: null,
                            ProviderDetails: null,
                            Instruments: [],
                        })
                    }
                    selected={data?.TransferType}
                    required="Please select"
                />
                <CedingScheme
                    data={data?.ProviderDetails}
                    onChange={(v) => this.onDataChange(onChange, v, data, "ProviderDetails")}
                    onRef={(ref) => this.appendChild(ref)}
                    type={data?.TransferType === TransferType.Cash ? SubAccountType.CashIsa : SubAccountType.StocksIsa}
                    showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                    index={this.props.index}
                    showElectronicRerRegistrationSupported={true}
                    jouneryType={this.props.jouneryType}
                />

                {data?.TransferType == TransferType.InSpecie && (
                    <RadiosEditor
                        cssWrapper="rg-150 mt-20 mb-0"
                        options={[true, false]}
                        getText={(v) => (v ? "Yes" : "No")}
                        onChange={(v) => {
                            if (!v) {
                                onChange({ InvestmentsToBeTransferredInSpecie: v, Instruments: [] });
                            } else {
                                onChange({ InvestmentsToBeTransferredInSpecie: v });
                            }
                        }}
                        selected={data?.InvestmentsToBeTransferredInSpecie}
                        label={"Are investments to be transferred in specie? "}
                        required={"Please select"}
                    />
                )}

                {data?.TransferType == TransferType.Cash && (
                    <>
                        <RadiosEditor
                            cssWrapper="rg-150 mt-38 mb-0"
                            options={[true, false]}
                            getText={(v) => (v ? "Yes" : "No")}
                            onChange={() => onChange({})}
                            selected={true}
                            disabled={true}
                            label={"Is the cash ISA to be transferred to a S&S ISA? "}
                            required={"please select"}
                        />
                        {(data?.CashIsaToBeTransferredToSSIsa || data?.TransferType == TransferType.Cash) && (
                            <>
                                <RadiosEditor
                                    cssWrapper="rg-150 mt-20 mb-0"
                                    options={[true, false]}
                                    getText={(v) => (v ? "Yes" : "No")}
                                    onChange={(v) => {
                                        onChange({ InternalTransferFromExistingWrapCashIsa: v });
                                        if (!v) {
                                            this.setState({ showLocation: true });
                                        } else if (v && this.props.hasCashIsa) {
                                            this.setState({ showLocation: true });
                                        } else {
                                            this.setState({ showLocation: false });
                                            this.props.showErrorMsgPopUp(
                                                ["No ISA cash sub account found for internal transfer."],
                                                true
                                            );
                                        }
                                    }}
                                    selected={data?.InternalTransferFromExistingWrapCashIsa}
                                    label={"Is this an internal transfer from an existing Wrap Cash ISA? "}
                                    required={"please select"}
                                />

                                {this.state.showLocation && (
                                    <SelectEditor
                                        cssWrapper="control-size-430 mt-20"
                                        options={[null, ...TransferLocationTypes]}
                                        getText={(v) => TransferLocationTypesMap[v]}
                                        selected={data?.Location}
                                        label="Location"
                                        onChange={(v) => onChange({ Location: v })}
                                        required="Please select "
                                    />
                                )}
                            </>
                        )}
                       {
                       <MoneyTextBoxEditor
                            cssWrapper="control-size-180 mt-15 mb-20"
                            label={"Cash value"}
                            currency={CurrencyCode.GBP}
                            onChange={(v) => onChange({ CurrentValue: { Amount: v, Currency: CurrencyCode.GBP } })}
                            value={data?.CurrentValue?.Amount}
                            required={"Please enter"}
                        /> } 
                    </>
                )}
                <RadiosEditor
                    cssWrapper="rg-150 mt-38 pb-20"
                    options={ExternalIsaContributionTypes}
                    getText={(v) => ExternalIsaContributionTypesMap[v]}
                    onChange={(v) => onChange({ ContributionType: v })}
                    selected={
                        data?.ContributionType == null
                            ? ExternalIsaContributionType.PreviousTaxYear
                            : data?.ContributionType
                    }
                    label={"Subscriptions included in the transfer"}
                    required="Please select"
                />
                {(data?.ContributionType == ExternalIsaContributionType.CurrentTaxYear ||
                    data?.ContributionType == ExternalIsaContributionType.PreviousAndCurrentTaxYear) && (
                    <>
                        <RadiosEditor
                            cssWrapper="rg-150 mt-20 mb-20"
                            options={[true, false]}
                            getText={(v) => (v ? "Yes" : "No")}
                            onChange={(v) => onChange({ FlexibleISA: v })}
                            selected={data?.FlexibleISA}
                            label={"Transfer from Flexible ISA?"}
                        />
                        <DatePicker
                            formGroupCssWrapper="control-size-180 mt-15 mb-15"
                            label={"Date of first subscription"}
                            selected={JsonDateParser.toDateNoOffset(data?.FirstSubscription)}
                            alwaysValidateOnUpdate={false}
                            atLeast={{
                                value: currentTaxYearStartDate,
                                errorMessage: `Current tax year is ${currentTaxYear}, Date should between ${JsonDateParser.getFormatDate(
                                    currentTaxYearStartDate,
                                    "dd/MM/yyyy"
                                )} and ${JsonDateParser.getFormatDate(currentTaxYearEndDate, "dd/MM/yyyy")}.`,
                            }}
                            atMost={{
                                value: new Date(),
                                errorMessage: ContentDatePicker.CannotBeInTheFuture,
                            }}
                            {...datePickerOptions}
                            onChange={(d) => {
                                onChange({ FirstSubscription: JsonDateParser.toJsonDateNoOffset(d) });
                            }}
                        />
                        <MoneyTextBoxEditor
                            cssWrapper="control-size-180 mt-15 pb-20 mb-0"
                            label={"Estimated current year subscription (£)"}
                            currency={CurrencyCode.GBP}
                            tooltip={IsaContents.ToolTip_EstimatedCurrentYearSubscriptions}
                            onChange={(v) =>
                                onChange({ CurrentYearSubscriptionValue: { Amount: v, Currency: CurrencyCode.GBP } })
                            }
                            value={data?.CurrentYearSubscriptionValue?.Amount}
                            atMost={{
                                errorMessage: "The limit is £20,000.00. Please re-enter",
                                value: 20000,
                            }}
                            required={"Please enter"}
                        />
                    </>
                )}
                {displayTextBoxEditor && !(data?.ProviderDetails?.Name?.toLowerCase() == "aps allowance subscription") && (
                    <TextBoxEditor
                        cssWrapper="control-size-180 mt-15 mb-20"
                        label="Existing ISA account number"
                        value={data.ExistingIsaAccountNumber}
                        maxLength={50}
                        required={"Please enter"}
                        regex={{ errorMessage: ValidatorContents.AlphaNumericWithSpace, value: AlphanumericWithSpace }}
                        onChange={(v) => this.props.onChange({ ExistingIsaAccountNumber: v })}
                    />
                )}
                {displayReRegInvestmentSeletion && (
                    <ReRegInvestmentSeletion
                        index={this.props.index}
                        isInternal={false}
                        data={data?.Instruments}
                        onChange={(changes) => onChange({ Instruments: changes })}
                        onRef={(ref) => this.appendChild(ref)}
                        type={SubAccountType.StocksIsa}
                        modelData={data}
                        accountServiceProposition={this.props.accountServiceProposition}
                        onReregValueChange={(v) =>
                            onChange({ ReRegisterValue: { Amount: v, Currency: CurrencyCode.GBP } })
                        }
                        isReview={this.props.isReview}
                        readonly={this.props.readonly}
                    />
                )}
                {data?.TransferType == TransferType.Cash && data?.ProviderDetails?.Name?.toLowerCase() == "aps allowance subscription" && (
                    <>
                        <div className="row">
                            <button
                                className="btn secondary label-offset mr-10"
                                onClick={() => this.setState({ showAccountSearch: true })}
                            >
                                Find Account
                            </button>
                            <button
                                className="btn secondary label-offset"
                                onClick={() => {
                                    onChange({ Instruments: [] });
                                    this.setState({ showAccountSearch: false });
                                    this.onDataChange(
                                        onChange,
                                        { PolicyNumber: null },
                                        data,
                                        "ExternalOwnershipDetails"
                                    );
                                }}
                            >
                                Clear
                            </button>
                        </div>
                    </>
                )}
                {data?.TransferType == TransferType.Cash && showAccountSearch && (
                    <Lightbox
                        show={showAccountSearch}
                        title={"Account to transfer"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showAccountSearch: false })}
                        type={LightboxType.Modal}
                        unclosable={false}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <AccountSearchForIsaCashPopup
                            onChange={(v, cgtExempt, changeOfBeneficial) => {
                                const fullName = v.Name.split(" ");
                                this.onDataChange(
                                    onChange,
                                    {
                                        PolicyNumber: v.ClAccountId,
                                        CgtExempt: cgtExempt,
                                        ChangeOfBeneficial: changeOfBeneficial,
                                    },
                                    data,
                                    "ExternalOwnershipDetails"
                                );
                                this.onDataChange(
                                    (changes) => this.onDataChange(onChange, changes, data, "ExternalOwnershipDetails"),
                                    { OwnerName: { Family: fullName[fullName.length - 1], Given: fullName[0] } },
                                    data.ExternalOwnershipDetails,
                                    "OwnedBy"
                                );
                                this.setState({ showAccountSearch: false, transferDestinationAccount: v});
                            }}
                            onInvestmentsChange={(v) => {
                                onChange({ Instruments: v});
                            }}
                            onLoadingInvestments={(v) => {
                                this.setState({ isLoadingInvestments: v });
                            }}
                            claccountId={this.props.claccountId}
                            serviceProposition={this.props.accountServiceProposition}
                            subAccountType={subAccountType}
                            showcgtExempt={false}
                        />
                    </Lightbox>
                )}

                {data?.TransferType == TransferType.InSpecie && data?.InvestmentsToBeTransferredInSpecie && data?.ProviderDetails?.Name?.toLowerCase() == "aps allowance subscription" && (
                    <>
                        <div className="row">
                            <button
                                className="btn secondary label-offset mr-10"
                                onClick={() => this.setState({ showAccountSearch: true })}
                            >
                                Find Account
                            </button>
                            <button
                                className="btn secondary label-offset"
                                onClick={() => {
                                    onChange({ Instruments: [] });
                                    this.setState({ showAccountSearch: false });
                                    this.onDataChange(
                                        onChange,
                                        { PolicyNumber: null },
                                        data,
                                        "ExternalOwnershipDetails"
                                    );
                                }}
                            >
                                Clear
                            </button>
                        </div>
                    </>
                )}
                {!(data?.TransferType == TransferType.Cash) && showAccountSearch && (
                    <Lightbox
                        show={showAccountSearch}
                        title={"Account to transfer"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showAccountSearch: false })}
                        type={LightboxType.Modal}
                        unclosable={false}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <AccountSearchPopup
                            onChange={(v, cgtExempt, changeOfBeneficial) => {
                                const fullName = v.Name.split(" ");
                                this.onDataChange(
                                    onChange,
                                    {
                                        PolicyNumber: v.ClAccountId,
                                        CgtExempt: cgtExempt,
                                        ChangeOfBeneficial: changeOfBeneficial,
                                    },
                                    data,
                                    "ExternalOwnershipDetails"
                                );
                                this.onDataChange(
                                    (changes) => this.onDataChange(onChange, changes, data, "ExternalOwnershipDetails"),
                                    { OwnerName: { Family: fullName[fullName.length - 1], Given: fullName[0] } },
                                    data.ExternalOwnershipDetails,
                                    "OwnedBy"
                                );
                                this.setState({ showAccountSearch: false, transferDestinationAccount: v});
                            }}
                            onInvestmentsChange={(v) => {
                                onChange({ Instruments: v});
                            }}
                            onLoadingInvestments={(v) => {
                                this.setState({ isLoadingInvestments: v });
                            }}
                            claccountId={this.props.claccountId}
                            serviceProposition={this.props.accountServiceProposition}
                            subAccountType={subAccountType}
                            showcgtExempt={false}
                        />
                    </Lightbox>
                )}

                {data.ExternalOwnershipDetails?.PolicyNumber != null &&
                    data?.ProviderDetails?.Name?.toLowerCase() == "aps allowance subscription" &&
                    data.Instruments &&
                    data.Instruments.length != 0 && (
                        <ReRegInvestmentSeletion
                            index={this.props.index}
                            isInternal={true}
                            data={data.Instruments}
                            onChange={(changes) => onChange({ Instruments: changes })}
                            onRef={(ref) => this.appendChild(ref)}
                            type={SubAccountType.StocksIsa}
                            accountServiceProposition={this.props.accountServiceProposition}
                            transferDestinationAccount={this.state.transferDestinationAccount}
                            modelData={data}
                            onReregValueChange={(v) =>
                                onChange({ ReRegisterValue: { Amount: v, Currency: CurrencyCode.GBP } })
                            }
                            isReview={this.props.isReview}
                            readonly={this.props.readonly}
                            isApsIsa={true}
                        />
                    )}
                    
            </>
        );
    }
}
